export default {
  enumConf: {
    // 广告状态
    AdvertiseStatus: [],
    // 广告来源
    AdvertiseSource: [],
    // 发布填报平台
    PresentPlatformType: [],
    // 推送渠道
    PushChannel: [],
    // 招商下店铺参与状态
    MerchantsPlanShopStatus: [],
    // 招商状态
    MerchantsPlanStatus: [],
    // 影响平台补贴的因素
    MerchantsPlanLayeredSubsidyType: [],
    // 选择目标商户途径
    MerchantsPlanShopFilterType: [],
    // 出价方式
    CostType: [],
  },
  adConf: {
    appHomeConfig: {
      title: '',
      desc: ['', ''],
      image: '',
    },
    appCreateConfig: {
      previewImages: '', // 创建页面预览图
      protocol: '', // 创建页面协议
      merchantsPlanImage: '', // 广告招商报名头图
    },
  },
}
